import React from "react";
import { Link } from "react-router-dom";
import { GROUP_REGISTRATION_ENABLED } from "../tools/registrationFlags";

const Footer = () => {
    return (
    <footer className="footer-gradient">
        <nav className="d-flex justify-content-between container">
            {/* <h4><a href="#d">Preguntas frecuentes</a></h4> */}
            {GROUP_REGISTRATION_ENABLED && (
                <h4><Link to='/login'>Registra a un grupo</Link></h4>
            )}
            <h4><a href="#d">RE-VALORÍZATE 2026</a></h4>
        </nav>
    </footer>
    )
}

export default Footer;